import React from 'react'
import PropTypes from 'prop-types'
import Container from './Container'
import Flower from '../assets/icons/flower.svg'
import BreadcrumbInHeader from '../components/BreadcrumbInHeader'

const ArticleHeader = ({ currentCategory, currentPage }) => {
  return (
    <div className="relative py-6 md:pt-6 md:pb-10 bg-gradient-r-primary">
      <Container>
        <div className="relative z-10">
          <BreadcrumbInHeader
            category={currentCategory}
            currentPage={currentPage}
          />
          <h1 className="text-3xl text-white">
            <span className="hidden">Help &amp; FAQs for:</span>
            <span className="font-semibold">{currentCategory}</span>
          </h1>
        </div>
      </Container>
      <div className="absolute top-0 bottom-0 left-0 right-0 w-full overflow-hidden">
        <Flower className="h-64 ml-auto mr-0 lg:h-auto" />
      </div>
    </div>
  )
}

ArticleHeader.propTypes = {
  currentCategory: PropTypes.string,
}

export default ArticleHeader
